import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getInputWrapperClass,
    getWholeDivWrapperClass,
} from "../../sharedStyles.tsx";
import {defaultParserForSelects} from "../../../dyanimcFormUtil.tsx";


const StaticCurrencyDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value, controller }) => {
    const { fieldState } = controller;

    const parsedValue = defaultParserForSelects(value);
    value = parsedValue && parsedValue?.label ? parsedValue.label : value;

    const displayValue =
        typeof value === "number" || !isNaN(Number(value))
            ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(Number(value))
            : "-";

    return (
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component} />
            <div className={getInputWrapperClass(component)}>
                <span className={getInputClassNames(component, fieldState)}>{displayValue}</span>
            </div>
            <FormError fieldState={fieldState} component={component} />
        </div>
    );
};

export const StaticCurrencyDisplay = React.memo(StaticCurrencyDisplayRenderer);